import { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorCode } from './Error';
import { mapError } from './mapError';
import ValidationResult from './ValidationResult';

export default class ErrorResponse extends ApiClientErrorResponse {
	handleProductGroupNotFound(): boolean {
		return this.handle('product-group-not-found');
	}

	handleProductGroupLocked(): boolean {
		return this.handle('product-group-locked');
	}

	handleCannotChangeSettingsForNonMemberProducts(): boolean {
		return this.handle(ErrorCode.cannotChangeSettingsForNonMemberProducts);
	}

	handleRequiredProductSettingsMissing(): boolean {
		return this.handle(ErrorCode.requiredProductSettingsMissing);
	}

	handleRequiresMinOneReferenceProduct(): boolean {
		return this.handle(ErrorCode.requiresMinOneReferenceProduct);
	}

	handleRequiresMaxOneReferenceProduct(): boolean {
		return this.handle(ErrorCode.requiresMaxOneReferenceProduct);
	}

	handleRequiresReferenceSettingsErrorCode(): boolean {
		return this.handle(ErrorCode.requiresReferenceSettings);
	}

	handleIllegalPriceTypeSelected(): boolean {
		return this.handle(ErrorCode.illegalPriceTypeSelected);
	}

	toValidationResult(): ValidationResult {
		const errors = this.errors.map(mapError);

		return new ValidationResult(
			errors.find((error) => error.code === ErrorCode.requiresReferenceSettings) !== undefined,
			errors.filter((error) => error.productId !== null),
			errors.filter((error) => error.duplicateCountries.length > 0)
		);
	}
}
